import { Clickable } from '@ahmdigital/ui';

import constants from '../../../../ahm-constants';

const welcomeData = [
  {
    analyticsLabel: 'hospital-extras-difference',
    body: (
      <>
        Hospital and extras cover are two different parts of health insurance that can work together to look after
        different needs.{' '}
        <Clickable analytics={{ label: 'Hospital cover' }} to={constants.URLS.SALES.HEALTH_INSURANCE_HOSPITAL_COVER}>
          Hospital cover
        </Clickable>{' '}
        can help pay for treatments or services included in your cover if you’re admitted to hospital as a private
        patient - things like your doctor’s fees, accommodation, and intensive care.{' '}
        <Clickable analytics={{ label: 'Extras cover' }} to={constants.URLS.SALES.HEALTH_INSURANCE_EXTRAS_COVER}>
          Extras cover
        </Clickable>{' '}
        on the other hand, can help with everyday health services that aren’t part of your hospital cover inclusions,
        and aren’t covered by Medicare - like dental check-ups, physio appointments, optical and more.
        <br />
        <br />
        Different products include cover for different things, so always make sure you check out what’s included.
      </>
    ),
    title: 'What’s the difference between hospital and extras cover?',
  },
  {
    analyticsLabel: 'combined-cover-benefits',
    body: (
      <>
        Getting <strong>hospital and extras cover</strong> together gives you one easy-to-manage policy, keeps things
        simple with one payment for both. Having combined <strong>hospital and extras</strong>{' '}
        <Clickable
          analytics={{ label: 'Health insurance explained' }}
          to={constants.URLS.SALES.EXPLAINED_HEALTH_INSURANCE_EXPLAINED}
        >
          health insurance
        </Clickable>{' '}
        can help you feel like your healthcare needs are being looked after both in hospital and out. Compare and
        mix-and-match our extras and hospital products to find a combined cover that suits your lifestyle and health
        goals.
      </>
    ),
    title: 'What are the benefits of a combined hospital and extras cover?',
  },
  {
    analyticsLabel: 'choose-combined-cover',
    body: (
      <>
        When choosing a hospital and extras cover with{' '}
        <Clickable analytics={{ label: 'ahm' }} to={constants.URLS.SALES.HOME}>
          ahm
        </Clickable>
        , consider your lifestyle, budget and the types of healthcare that matter most to you. Select the services you
        want to include, and compare hospital and extras cover options to find a suitable health insurance package that
        offers the right balance of hospital care and everyday support for you.
      </>
    ),
    title: 'How should I choose a combined hospital and extras cover?',
  },
];

export default welcomeData;
